<h2 mat-dialog-title> Modificar usuario</h2>
<mat-dialog-content>

  <mat-tab-group animationDuration="0ms">
    <mat-tab label="Información" class='tab'>
      <form [formGroup]="form">
        <mat-form-field class='formField'>
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="name" [(value)]="name" required>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Apellidos</mat-label>
          <input matInput placeholder="Apellidos" formControlName="surname" [(value)]="surname" required>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" [(value)]="email" required>
        </mat-form-field>
        <!--<mat-form-field class='formField'>
        <mat-label>Rol</mat-label>
        <mat-select formControlName="rol" [(value)]="rol" required>
          <mat-option value="admin">Administrador</mat-option>
          <mat-option value="trans">Transportista</mat-option>
          <mat-option value="clasi">Clasificador</mat-option>
          <mat-option value="ofici">Oficina</mat-option>
        </mat-select>
        <mat-error>El rol es obligatorio</mat-error>
      </mat-form-field>-->
      <mat-form-field class='formField'>
        <mat-label>Estado</mat-label>
        <mat-select formControlName="active" [(value)]="active" required>
          <mat-option value="true">Activo</mat-option>
          <mat-option value="false">Inactivo</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-tab>
  <mat-tab label="Permisos" class='tab'>
    <table class='table'>
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Control total</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_total"></mat-slide-toggle></td>
        </tr>
      }
      <tr>
        <td>Pesar</td>
        <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_pesar" (change)="onPermisoPesarToggle()"></mat-slide-toggle></td>
      </tr>
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Clasificar</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_clasificar"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Ver registros</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registros"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Modificar datos</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registrosDatos"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Modificar pesos</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registrosPesos"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Gestión usuarios</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_usuarios"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>Gestión contenedores</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>- Alta movimiento</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores_alta_movimientos"></mat-slide-toggle></td>
        </tr>
      }
      @if (userRolCheck('permiso_total')) {
        <tr>
          <td>- Alta mantenimiento</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores_alta_mantenimientos"></mat-slide-toggle></td>
        </tr>
      }
    </table>
  </mat-tab>
  @if (permiso_pesar) {
    <mat-tab label="Básculas" class='tab'>
      @if (scalesLoading) {
        <p>Cargando básculas…</p>
      } @else {
        @if (scalesError) {
          <p>{{ scalesError }}</p>
        } @else if (allScales.length === 0) {
          <p>No hay básculas activas.</p>
        } @else {
          <div class="scalesList">
            @for (scale of allScales; track scale.id) {
              <mat-checkbox
                color="primary"
                [checked]="isScaleSelected(scale.id)"
                (change)="toggleScale(scale.id, $event.checked)">
                {{ scale.name }}
              </mat-checkbox>
            }
          </div>
        }
      }
    </mat-tab>
  }
</mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Modificar</button>
</mat-dialog-actions>
